/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import EmptyState from '@atlaskit/empty-state';
import type { EmptyStateProps } from '@atlaskit/empty-state/types';
import Image from '@atlaskit/image';
import Text from '@atlaskit/primitives/text';

import SearchNoResultsDark from './assets/no-results-dark.svg';
import SearchNoResultsLight from './assets/no-results-light.svg';

const styles = cssMap({
	textWrapper: {
		maxWidth: '235px',
		marginInline: 'auto',
	},
});

export type GlobalSideNavigationNoContentProps = {
	testId?: string;
	renderImage?: EmptyStateProps['renderImage'];
	heading: string;
	description: string;
};

export function GlobalSideNavigationNoContent({
	testId = 'global-side-navigation--no-content',
	renderImage = () => (
		<Image
			testId="global-side-navigation--no-content-default-image"
			src={SearchNoResultsLight}
			srcDark={SearchNoResultsDark}
			width={96}
			alt=""
		/>
	),
	heading,
	description,
}: GlobalSideNavigationNoContentProps) {
	return (
		<EmptyState
			testId={testId}
			renderImage={renderImage}
			header={heading}
			headingLevel={3}
			headingSize="xsmall"
			description={
				<div css={styles.textWrapper}>
					<Text size="small" color="color.text.subtle">
						{description}
					</Text>
				</div>
			}
		/>
	);
}
